import Control from './Control'

export default Control
